import { TimeoutModalComponent } from '../timeout-modal/timeout-modal.component';
import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LoginService } from 'src/app/services/login-service/login.service';

import { DialogService } from 'primeng/dynamicdialog';
import { ConfigService } from '../../services/config-service/config.service';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { FeedbackModalComponent } from '../app-feedback-modal-content/app-feedback-modal-content.component';
import { Router } from '@angular/router';
import { MixpanelService } from '../../services/mixpanel-service/mixpanel.service';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  private _menuItems_: any;
  loggedIn = false;
  loginMenuItems: MenuItem[];
  user: any = null;
  currentRoute: any = '';

  public idleState = 'NOT_STARTED';
  public lastPing?: Date = new Date();
  public userSubs$ = new Subject();
  public subscription!: Subscription;
  public openMenuModal = false;

  public get menuItems(): Array<MenuItem> {
    return this._menuItems_;
  }

  constructor(
    public dialogService: DialogService,
    private configService: ConfigService,
    private loginService: LoginService,
    private mixpanelService: MixpanelService,
    private route: Router,
    public auth: AuthService
  ) {
    this.currentRoute = this.route;
    this.configService._config_$.subscribe((configUrls) => {
      const searchCarsMenuItem: MenuItem = {
        label: 'Railcar Search',
        routerLink: ['/search-inventory'],
      };
       const newRailCarBuilds: MenuItem = {
        label: 'NEW RAILCAR BUILDS',
        routerLink: ['/new-builds'],
      };
      const fleetFinderMenuItem: MenuItem = {
        label: 'Fleet Finder',
        url: configUrls.fleetFinderURL,
      };
      // const howItWorksMenuItem     : MenuItem = { label: 'FAQS', routerLink: [ '/how-it-works']};
      this._menuItems_ = [];
    });

    this.loginMenuItems = [
      {
        items: [
          {
            label: 'Launch Page',
            routerLink: '/launch',
            id: 'my-dashboard',
            command: () => {
              this.goToLaunchPage();
            },
          },
          {
            label: 'My Account',
            routerLink: '/account',
            id: 'my-account',
            command: () => {
              this.goToMyAccount();
            },
          },
          {
            label: 'Feedback',
            id: 'feedback',
            command: () => {
              this.showFeedbackModal();
            },
          },
          {
            label: 'Sign Out',
            id: 'sign-out',
            command: () => {
              this.signOut();
            },
          },
        ],
      },
    ];

    const rslt = this.loginService.isSessionValid();
    if (rslt) {
      this.loginService.getUser()?.subscribe({
        next: (response: any) => {
          this.user = response[0].json_build_object;
          this.loginService.setUser(response[0].json_build_object);
        },
      });
    }

    this.loginService.user$.subscribe((res) => {
      this.user = res;
      if (this.user) {
        const source = interval(120000).pipe(takeUntil(this.userSubs$));
        this.subscription = source.subscribe((val) => this.validateSession());
      } else {
        this.subscription?.unsubscribe();
        this.userSubs$.next(false);
        this.userSubs$.complete();
      }
    });
  }

  validateSession() {
    const rslt = this.loginService.isSessionValid();
    if (!rslt) {
      this.signOut();
      this.subscription?.unsubscribe();
      this.userSubs$.next(false);
      this.userSubs$.complete();
      this.dialogService.open(TimeoutModalComponent, {
        closeOnEscape: false,
        closable: false,
        styleClass: 'timeout-modal',
      });
    }
  }

  signOut() {
    const userEmail = localStorage.getItem('userEmail') || '';
    this.mixpanelService.track({
      id: userEmail,
      eventName: 'Sign out',
      eventDisplayName: 'Sign out',
      kpi: 'Click-Through Rate',
      trigger: 'On Button Click',
      eventDefinition: 'User clicks the sign-out button',
      propertyType: 'Event Property',
      propertyDefinition: 'Button Label Signout',
    });
    this.mixpanelService.reset();
    this.loginService.signout();
  }

  isActive(routerLink: any) {
    const path = window.location.pathname;

    // If fromNewBuilds is true, highlight only NEW RAILCAR BUILDS
    if (
      localStorage.getItem('fromNewBuilds') === 'true' &&
      routerLink !== undefined
    ) {
      return routerLink.includes('/new-builds');
    }

    // Otherwise, follow the regular logic to highlight based on the current path
    return path.includes(routerLink);
  }

  showLoginModal() {
    const userEmail = localStorage.getItem('userEmail') || '';
    this.mixpanelService.register(userEmail);
    this.auth.loginWithRedirect();
  }

  showFeedbackModal() {
    const ref = this.dialogService.open(FeedbackModalComponent, {
      header: 'TRM Feedback',
      width: '980px',
      closeOnEscape: false,
    });

    ref.onClose.subscribe(() => {
      // handle dialog close
    });
  }
  openMenuModalham() {
    this.openMenuModal = !this.openMenuModal;
  }
  signOutbtn() {
    this.openMenuModal = false;
    const userEmail = localStorage.getItem('userEmail') || '';
    this.mixpanelService.track({
      id: userEmail,
      eventName: 'sign_out_click',
      eventDisplayName: 'Sign Out Button Click',
      kpi: 'Click-Through Rate',
      trigger: 'On Button Click',
      eventDefinition: 'User clicks the sign-out button',
      propertyType: 'Event Property',
      propertyDefinition: 'Button Label',
    });

    this.signOut();
  }
  goToMyAccount() {
    this.openMenuModal = false;
    this.route.navigateByUrl('/account');
  }
  goToLaunchPage() {
    this.route.navigate(['/launch']);
  }
  goToSearchInventory() {
    const userEmail = localStorage.getItem('userEmail') || '';
    this.mixpanelService.trackBeginTime(
      'Railcar Search button click time',
      userEmail
    );
    this.mixpanelService.track({
      id: userEmail,
      eventName: 'Search',
      eventDisplayName: 'Railcar Search Menu Click',
      kpi: 'User Engagement',
      trigger: 'On Menu Item Click',
      eventDefinition: 'User clicks the Railcar Search menu item',
      propertyType: 'Event Property',
      propertyDefinition: 'Menu Item Label',
    });
    this.openMenuModal = false;
    this.route.navigateByUrl('/search-inventory');
  }

  setMixpanelTrack(evt: string) {
    const userEmail = localStorage.getItem('userEmail') || '';
    const eventName =
      evt === 'search' ? 'searchinventorymenuclick' : 'fleetfinder_menu_click';
    const eventDefinition =
      evt === 'search'
        ? 'User clicks the Railcar Search menu item'
        : 'User clicks the Fleet Finder menu item';

    this.mixpanelService.track({
      id: userEmail,
      eventName: eventName,
      eventDisplayName: `${
        evt === 'search' ? 'Railcar Search' : 'Fleet Finder'
      } Menu Click`,
      kpi: 'User Engagement',
      trigger: 'On Menu Item Click',
      eventDefinition: eventDefinition,
      propertyType: 'Event Property',
      propertyDefinition: 'Menu Item Label',
    });
  }
}
